module.exports = __webpack_public_path__ + "img/ii4-gender-perspectives.60d1a5a9.png";